import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Constants from '../../definitions/constants';

const PrivateRoute = ({component: Component, layoutComponent: LayoutComponent, cookies, fullHeight, ...rest}) => {
  let onServer = false;
  if (typeof window === 'undefined') {
    onServer = true
  }
  return (
      // Show the component only when the user is logged in
      // Otherwise, redirect the user to /signin page
      <Route {...rest} render={props => (
          (cookies.get("auth") || onServer) ?
              <LayoutComponent {...props} fullHeight={fullHeight}>
                <Component {...props} />
              </LayoutComponent>                
          : <Redirect to={Constants.app.routes.login} />
      )} />
  );
};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./source/router/routeTypes/privateRoute.jsx